import React from 'react';

const ProjectsFilters = ({
  languageFilter,
  languageOptions,
  onLanguageChange,
  onSortChange,
  sortOption,
  sortOptions,
  status,
}) => {
  if (status !== 'success') {
    return null;
  }

  return (
    <div className="mb-10 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div className="w-full sm:max-w-xs">
        <label htmlFor="project-sort" className="block text-sm font-semibold text-gray-700">
          Ordenar por
        </label>
        <select
          id="project-sort"
          value={sortOption}
          onChange={onSortChange}
          className="mt-2 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          {sortOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      <div className="w-full sm:max-w-xs">
        <label htmlFor="project-language" className="block text-sm font-semibold text-gray-700">
          Linguagem
        </label>
        <select
          id="project-language"
          value={languageFilter}
          onChange={onLanguageChange}
          className="mt-2 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-gray-700 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="all">Todas</option>
          {languageOptions.map((language) => (
            <option key={language} value={language}>
              {language}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default ProjectsFilters;
